import type { HTMLAttributes } from "react";
import React, { createContext, useCallback, useContext } from "react";

type SlotRegistration = (node: HTMLElement | null) => void;

export const PageAlertsSlotContext = createContext<SlotRegistration | null>(null);

/**
 * Marks where the page alerts should be rendered. PageWithNav shows them above the content by
 * default; a screen that mounts this slot receives them instead, wherever its own layout puts it.
 * Registering happens through a ref callback, so the alerts are relocated before the first paint.
 */
export function PageAlertsSlot(props: Readonly<HTMLAttributes<HTMLDivElement>>) {
  const register = useContext(PageAlertsSlotContext);
  const ref = useCallback((node: HTMLDivElement | null) => register?.(node), [register]);

  return <div ref={ref} {...props} />;
}
